import React, { FC } from 'react';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import './SectionCard.scss';
import { ToogleLinkButton } from 'app/components/ToogleLinkButton/ToogleLinkButton';
import { BUTTON } from 'app/components/ToogleLinkButton/models.d';
import Typography from 'app/components/Typography';
import { SectionI } from 'app/adapters/Sections';
import { TYPOGRAPHY } from 'app/components/Typography/models.d';

const SectionCard: FC<SectionI> = ({
  title,
  description,
  image,
  image_mobile,
  internal_insight,
  internal_page,
  external_url,
}) => {
  const { xl } = useBreakpoint();

  const renderBtn =
    internal_page || internal_insight ? (
      <ToogleLinkButton
        version={BUTTON.VERSION.INTERNAL_LINK}
        link={
          internal_page
            ? `/${internal_page.slug}`
            : internal_insight
            ? `/insights/${internal_insight.page_url}`
            : ''
        }
        color={BUTTON.COLOR.BLUE_DARK}
      >
        Learn More
      </ToogleLinkButton>
    ) : external_url ? (
      <ToogleLinkButton
        version={BUTTON.VERSION.EXTERNAL_LINK}
        link={external_url}
        color={BUTTON.COLOR.BLUE_DARK}
      >
        Learn More
      </ToogleLinkButton>
    ) : null;

  return (
    <div className="article-card">
      <div className="article-card__header">
        <img
          src={xl ? image ?? '' : image_mobile ?? ''}
          alt={title}
          className="article-card__img"
        />
      </div>
      <div className="article-card__body">
        <Typography
          variant={TYPOGRAPHY.VARIANT.H4}
          className="article-card__title"
        >
          {title}
        </Typography>
        <Typography
          variant={TYPOGRAPHY.VARIANT.P}
          color={TYPOGRAPHY.COLOR.BLACK}
          className="article-card__description"
        >
          {description}
        </Typography>
        <div className="article-card__btn">{renderBtn}</div>
      </div>
    </div>
  );
};

export default SectionCard;
